<template>
  <div
    v-if="oidcIsAuthenticated"
    class="protected"
  >
    <!-- <SignedInUser /> -->
    <ChangePassword />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import SignedInUser from '@/components/SignedInUser'
import ChangePassword from '@/components/ChangePassword'

export default {
  name: 'Protected',
  components: { ChangePassword },
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcUser'
    ])
  }
}
</script>
